import React from 'react';
import { TransactionEntity, TransactionType } from './types';
import { AccountTransactionRecord } from '../services/transaction/types';

type AccountTransactionProps = {
    transaction: AccountTransactionRecord;
}

const DerivedDescriptionCell = ( { transaction }: AccountTransactionProps ) => {
    const type = transaction.type;

    switch(transaction.xTransactionEntity){
        case TransactionEntity.ACCOUNT:
            return ( type === TransactionType.AFFILIATE_PURCHASE
                || type === TransactionType.SURVEY
            ? <span>Rewarded</span> : null)
        case TransactionEntity.IMPACT:
        case TransactionEntity.SURVEY:
            return <span>Pending</span>;
        case TransactionEntity.PAYMENT:
            return <span>Distributed</span>;
        default:
            if (transaction.type === TransactionType.PAYMENT_REQUEST)
                return <span>Pending</span>;
            return <span>{ type }</span>;
    }
}

export default DerivedDescriptionCell;